import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthentificationComponent } from './authentification/authentification.component';
import { NotFoundComponent } from './shared/index';
import { DashboardComponent } from './dashboard/dashboard/dashboard.component';
import { AutheticationGuard } from './authetication.guard';
import { UiSettingComponent } from './ui-setting/ui-setting.component';
import { OperatorVehiclesComponent } from './operator-vehicles/operator-vehicles.component';
import { UsersComponent } from '@app/users/users/users.component';
import { TariffPageComponent } from '@app/driver-tariffs/tariff-page/tariff-page.component';
import { PhoneReportsComponent } from './phone-reports/phone-reports/phone-reports.component';
import { PassengersComponent } from './passengers/passengers/passengers.component';
import { RedmineReportsComponent } from './redmine-reports/redmine-reports.component';
import { NoAuthGuard } from './no-auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AutheticationGuard] },
  { path: 'login', component: AuthentificationComponent, canActivate: [NoAuthGuard] },
  { path: 'orders-archive', loadChildren: './orders-archive/orders-archive.module#OrdersArchiveModule' },
  { path: 'dynamic-rates', loadChildren: './fare-editor/fare-editor.module#FareEditorModule', canActivate: [AutheticationGuard]},
  { path: 'client-app', component: UiSettingComponent, canActivate: [AutheticationGuard] },
  // { path: 'setconfig', component: ServiceConfEditComponent, canActivate: [AutheticationGuard] },
  { path: 'setconfig', loadChildren: './config/config.module#ConfigModule', canActivate: [AutheticationGuard] },
  { path: 'car-manage', component: OperatorVehiclesComponent, canActivate: [AutheticationGuard] },
  { path: 'users', component: UsersComponent, canActivate: [AutheticationGuard] },
  { path: 'driver-tariffs', component: TariffPageComponent, canActivate: [AutheticationGuard] },
  { path: 'passengers', component: PassengersComponent, canActivate: [AutheticationGuard] },
  {
    path: 'accounting', canActivate: [AutheticationGuard],
    loadChildren: './accounting/accounting.module#AccountingModule'
  },
  {
    path: 'logist', canActivate: [AutheticationGuard],
    loadChildren: './logist-room/logist-room.module#LogistRoomModule'
  },
  {
    path: 'management', canActivate: [AutheticationGuard], children: [
      { path: '', redirectTo: 'cab', pathMatch: 'full' },
      {
        path: 'cab',
        loadChildren: './cab/cab.module#CabModule'
      }
    ]
  },
  {
    path: 'redmine', component: RedmineReportsComponent, canActivate: [AutheticationGuard]
  },
  { path: 'phone-reports', component: PhoneReportsComponent, canActivate: [AutheticationGuard] },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts